<template>
  <BaseLoader
    :is-active="isRootLoading"
    :class="$style.viewLoader"
  >
    <AssemblyView
      v-if="!isRootLoading"
      ref="view"
      :class="$style.view"
      :root="root"
      @toggleNode="toggleNode"
      @clickNode="clickNode"
    />
    <router-link
      #="{ navigate }"
      :to="{
        name: 'Products/Car',
        params: { carId: $route.params.carId },
      }"
      custom
    >
      <button
        type="button"
        :class="$style.back"
        @click="navigate"
      >
        Back to Car
      </button>
    </router-link>
  </BaseLoader>
</template>

<script>
import gql from 'graphql-tag';
import BaseLoader from '@/components/base/Loader';
import AssemblyView from '@/components/AssemblyView';

const getNextId = (() => {
  let id = 0;
  return () => {
    id += 1;
    return id;
  };
})();

const TYPES = {
  car: 'CAR',
  ldv: 'LDV',
  ldvbom: 'LDVBOM',
};

export default {
  components: {
    BaseLoader,
    AssemblyView,
  },
  data() {
    return {
      isRootLoading: true,
      root: {},
    };
  },
  mounted() {
    this.loadRoot();
  },
  methods: {
    async loadRoot() {
      const res = await this.$apollo.query({
        query: gql`
            query ($carId: Int!) {
              cars_by_pk(id: $carId) {
                side_image
                model
                lighting_configurations(limit: 1) {
                  id
                }
              }
            }
        `,
        variables: {
          carId: this.$route.params.carId,
        },
      });

      const data = res.data.cars_by_pk;

      this.root = {
        id: getNextId(),
        dataId: this.$route.params.carId,
        type: TYPES.car,
        image: data.side_image,
        title: data.model,
        hasChildren: data.lighting_configurations.length !== 0,
      };

      this.isRootLoading = false;
    },
    async getChildren(nodeDataType, nodeDataId) {
      if (nodeDataType === TYPES.car) {
        const res = await this.$apollo.query({
          query: gql`
            query ($carId: Int!) {
              lighting_configurations(where: {car_id: {_eq: $carId}}, limit: 100) {
                lighting_device {
                  id
                  front_image
                  supplier {
                    name
                  }
                  part_number
                }
              }
            }
        `,
          variables: {
            carId: nodeDataId,
          },
        });

        const data = res.data.lighting_configurations;

        return data.map(({ lighting_device: device }) => ({
          id: getNextId(),
          dataId: device.id,
          type: TYPES.ldv,
          image: device.front_image,
          title: `${device.supplier.name} / ${device.part_number}`,
          // hasChildren: device.ldvsboms.length !== 0,
        }));
      }

      // if (nodeDataType === TYPES.ldv) {
      //   const res = await this.$apollo.query({
      //     query: gql`
      //       query ($ldvId: Int!) {
      //         ldvsboms(where: {ldv_id: {_eq: $ldvId}}, limit: 100) {
      //           id
      //           img
      //         }
      //       }
      //   `,
      //     variables: {
      //       ldvId: nodeDataId,
      //     },
      //   });
      //
      //   const data = res.data.ldvsboms;
      //
      //   return data.map((bom) => ({
      //     id: getNextId(),
      //     dataId: bom.id,
      //     type: TYPES.ldvbom,
      //     image: bom.img,
      //     title: '',
      //   }));
      // }

      return [];
    },
    async toggleNode(id) {
      const node = this.$refs.view.getNode(id);

      if (node.isExpanded) {
        this.$refs.view.collapseNode(id);
      } else {
        this.$refs.view.expandNode(id, await this.getChildren(node.type, node.dataId));
      }
    },
    clickNode(id) {
      const node = this.$refs.view.getNode(id);

      if (node.type === TYPES.car) {
        const route = this.$router.resolve({
          name: 'Products/Car',
          params: { carId: node.dataId },
        });
        window.open(route.href, '_blank');
      } else if (node.type === TYPES.ldv) {
        const route = this.$router.resolve({
          name: 'Products/Device',
          params: { deviceId: node.dataId },
        });
        window.open(route.href, '_blank');
      }
    },
  },
};
</script>

<style lang="scss" module>
.viewLoader {
  position: relative;
  display: flex;
  flex-direction: column;
  flex-grow: 1;
}

.view {
  flex-grow: 1;
}

.back {
  @include reset;
  position: absolute;
  top: 20px;
  left: 20px;
  display: inline-block;
  padding: 13px 18px 11px;
  font-size: 16px;
  font-weight: 600;
  color: $title;
  cursor: pointer;
  background: $white;
  border: 1px solid $disabled;
  border-radius: 5px;
  transition: background 0.2s ease-in-out;

  &:hover {
    background: $background-light;
  }
}
</style>
